import { createSelector } from 'reselect';


export const editQuestionLoadingSelector = createSelector(
    [state => state.fileConnection.meta.fetch],
    (isFileFetch) => {
        return isFileFetch;
    }
)
